import { useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import "@/App.css";
import "@/index.css";
import { AuthProvider } from './lib/auth';
import Header from './components/Header';
import Footer from './components/Footer';
import AIChatWidget, { AIChatLauncher } from './components/AIChatWidget';
import Home from './pages/Home';
import Events from './pages/Events';
import EventDetail from './pages/EventDetail';
import MapPage from './pages/MapPage';
import Submit from './pages/Submit';
import Dashboard from './pages/Dashboard';
import Admin from './pages/Admin';
import Organizer from './pages/Organizer';
import TripPlanner from './pages/TripPlanner';
import AuthCallback from './pages/AuthCallback';
import { Toaster } from './components/ui/sonner';
import PWAInstallPrompt from './components/PWAInstallPrompt';
import NewsletterPopup from './components/NewsletterPopup';

function AppShell() {
  const [chatOpen, setChatOpen] = useState(false);
  const location = useLocation();

  // OAuth callback handler (synchronous check during render)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <>
      <Header onOpenChat={() => setChatOpen(true)} />
      <main className="min-h-[60vh]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/events" element={<Events />} />
          <Route path="/events/:id" element={<EventDetail />} />
          <Route path="/map" element={<MapPage />} />
          <Route path="/submit" element={<Submit />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/organizer" element={<Organizer />} />
          <Route path="/plan" element={<TripPlanner />} />
        </Routes>
      </main>
      <Footer />
      {!chatOpen && <AIChatLauncher onClick={() => setChatOpen(true)} />}
      <AIChatWidget open={chatOpen} onClose={() => setChatOpen(false)} />
      <PWAInstallPrompt />
      <NewsletterPopup />
      <Toaster richColors position="top-right" />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppShell />
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
